// @ts-nocheck
import React from 'react';
import styled from 'styled-components';

import { SliderProps } from './types';

interface CustomSliderProps extends SliderProps {
  itemGap: number;
  paddingEdges: boolean;
  slidesClassName?: string;
}

const SliderWrapper = styled.div<CustomSliderProps>`
  & div.js_slide {
    white-space: normal;
    line-height: 1.5;
    font-size: unset;
    margin-left: ${props => props.itemGap / 2}px;
    margin-right: ${props => props.itemGap / 2}px;
    width: ${props => props.itemWidth};
    height: ${props => props.itemHeight};
    &:first-child {
      width: ${props => `calc(${props.itemWidth} + ${props.itemGap}px)`};
      padding-left: ${props => (props.paddingEdges ? props.itemGap : 0)}px;
    }
    &:last-child {
      width: ${props => `calc(${props.itemWidth} + ${props.itemGap}px)`};
      padding-right: ${props => (props.paddingEdges ? props.itemGap / 2 : 0)}px;
    }
  }
`;

const Frame = styled.div`
  /**
  * (optional) wrapper width, specifies width of the slider frame.
  */
  width: 100%;

  position: relative;
  font-size: 0;
  line-height: 0;
  overflow: hidden;
  white-space: nowrap;
`;

const SliderSkeleton = React.forwardRef<
  HTMLDivElement,
  {
    childrens: React.ReactNode[];
  } & CustomSliderProps
>(
  (
    {
      childrens,
      itemWidth,
      itemGap,
      itemHeight,
      paddingEdges,
      slidesClassName,
    },
    ref,
  ) => {
    return (
      <SliderWrapper
        itemWidth={itemWidth}
        itemGap={itemGap}
        itemHeight={itemHeight}
        paddingEdges={paddingEdges}
      >
        <div className="slider relative" ref={ref}>
          <Frame className="frame js_frame inline-block relative">
            <div
              className={`slides js_slides inline-block relative ${slidesClassName}`}
            >
              {childrens.map((elementJsx, index) => (
                <div
                  className="js_slide inline-block relative overflow-hidden"
                  key={index}
                >
                  {elementJsx}
                </div>
              ))}
            </div>
          </Frame>
        </div>
      </SliderWrapper>
    );
  },
);

export default SliderSkeleton;
